/**
 * Zoom levels for timeline views
 * Story 2.7: Timeline Zoom & Scrolling
 */
export enum ZoomLevel {
    Day = 'Day',
    Week = 'Week',
    Sprint = 'Sprint', // 2 weeks
    Month = 'Month',
}

/**
 * Pixels per day for each zoom level
 */
export const ZOOM_LEVEL_DAY_WIDTH: Record<ZoomLevel, number> = {
    [ZoomLevel.Day]: 120,
    [ZoomLevel.Week]: 60,
    [ZoomLevel.Sprint]: 30,
    [ZoomLevel.Month]: 15,
};

/**
 * D3 tick interval for each zoom level
 */
export const ZOOM_LEVEL_TICK_LABEL: Record<ZoomLevel, string> = {
    [ZoomLevel.Day]: 'Day',
    [ZoomLevel.Week]: 'Week',
    [ZoomLevel.Sprint]: '2-Week Sprint',
    [ZoomLevel.Month]: 'Month',
};

/**
 * Timeline view state persisted per view
 */
export interface TimelineViewState {
    zoomLevel: ZoomLevel;
    scrollPosition: number;
}

/**
 * Ordered list of zoom levels (finest to coarsest) for keyboard +/- navigation
 */
export const ZOOM_LEVEL_ORDER: ZoomLevel[] = [
    ZoomLevel.Day,
    ZoomLevel.Week,
    ZoomLevel.Sprint,
    ZoomLevel.Month,
];
